/** BS1 — Barberías: panel del local, afiliaciones y lado del barbero. */
import { api } from '@/lib/api';

import { localeTag } from '@/contexts/LanguageContext';
export const shopsApi = {
  config() { return api.get('/shops/config'); },
  me() { return api.get('/shops/me'); },
  invite(username, pct, mode = 'pct', rent = null) { return api.post('/shops/me/barbers', { username, pct, mode, rent }); },
  setPct(affId, pct) { return api.patch(`/shops/me/barbers/${affId}`, { pct }); },
  // F1 alquiler (oct-2026): edita los términos de una invitación (modo + % o renta) en caliente.
  setTerms(affId, payload) { return api.patch(`/shops/me/barbers/${affId}`, payload); },
  // Acuerdo (21-sep-2026): la barbería PROPONE, el barbero acepta antes de que aplique. mode pct|rent.
  proposeAgreement(affId, default_pct, per_service = {}, mode = 'pct', rent = null) {
    return api.post(`/shops/me/barbers/${affId}/agreement`, { default_pct, per_service, mode, rent });
  },
  // Libro de alquiler (registro manual, sin Stripe).
  rent() { return api.get('/shops/me/rent'); },
  rentPaid(chargeId, note = null) { return api.post(`/shops/me/rent/charges/${chargeId}/paid`, { note }); },
  rentUnpaid(chargeId) { return api.delete(`/shops/me/rent/charges/${chargeId}/paid`); },
  withdrawAgreement(affId) { return api.delete(`/shops/me/barbers/${affId}/agreement`); },
  barberServices(affId) { return api.get(`/shops/me/barbers/${affId}/services`); },
  acceptAgreement() { return api.post('/shops/barber/me/agreement/accept', {}); },
  rejectAgreement() { return api.post('/shops/barber/me/agreement/reject', {}); },
  remove(affId) { return api.delete(`/shops/me/barbers/${affId}`); },
  // Parte 2c/3 (founder 14-oct-2026)
  setPremiumOutside(affId, enabled) { return api.patch(`/shops/me/barbers/${affId}/premium-outside`, { enabled }); },
  afterHours(username, date = null) { return api.get(`/shops/${username}/after-hours${date ? `?date=${date}` : ''}`); },
  mine() { return api.get('/shops/barber/me'); },
  accept(affId) { return api.post(`/shops/invites/${affId}/accept`, {}); },
  decline(affId) { return api.post(`/shops/invites/${affId}/decline`, {}); },
  leave() { return api.post('/shops/barber/me/leave', {}); },
  publicShop(username) { return api.get(`/shops/${encodeURIComponent(username)}`); },
  // F2 (oct-2026) — agenda del equipo: columnas por barbero afiliado (gestor sin dinero).
  agenda(date) { return api.get(`/shops/me/agenda?date=${encodeURIComponent(date)}`); },
  // F3 (oct-2026) — horario del local (base para todos los barberos). 409 ⇒ citas en conflicto; confirm=true guarda igual.
  hours() { return api.get('/shops/me/hours'); },
  saveHours(week, confirm = false) { return api.put('/shops/me/hours', { week, confirm }); },
  previewHours(week) { return api.post('/shops/me/hours/preview', { week }); },
  // Reporte de ingresos por barbero (solo lectura). Sin fechas ⇒ mes en curso en la zona del negocio.
  report({ from, to, barberId } = {}) {
    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    if (barberId) qs.set('barber_id', barberId);
    const s = qs.toString();
    return api.get(`/shops/me/report${s ? `?${s}` : ''}`);
  },
};

export const fmtPct = (v) => `${Number(v || 0).toLocaleString(localeTag(), { maximumFractionDigits: 1 })}%`;
